<template>
  <vv-desktop-tile
    :title="masterclass.title"
    :secondary="durationLabel"
    :image="image"
    :status="status"
    @click="handleClick"
    v-if="$mq == 'desktop'"
  />
  <vv-mobile-tile
    :title="masterclass.title"
    :secondary="durationLabel"
    :image="image"
    :status="status"
    :id="id"
    @click="handleClick"
    v-else
  />
</template>

<script>
import get from 'lodash/get'
import { mapGetters } from 'vuex'

import  VvDesktopTile from '@/components/common/Vv-Desktop-visite.vue'
import VvMobileTile from '@/components/common/VvMobileVisite.vue'
import { isMasterclassComplete, isMasterclassStarted } from '@/helpers/userCompletion'
import DownloadButton from '@/components/download/DownloadButton'

export default {
  name: 'MasterclassTile',
  components: { VvDesktopTile, VvMobileTile, DownloadButton },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      downloadStatus: 'none'
    }
  },
  computed: {
    ...mapGetters({
      theme: 'getThemeById',
    }),
    masterclass() {
      return this.theme(this.id)
    },
    lessonSteps() {
      return this.masterclass.lessonSteps.map(lessonStep => this.$store.state.lesson.lessonStep.byId[lessonStep.id])
    },
    lessons() {
      const allLessonIds = this.lessonSteps.reduce(
        (accumulator, lessonStep) => [...accumulator, ...lessonStep.lessons],
        []
      )

      return allLessonIds.map(id => this.$store.state.lesson.lesson.byId[id])
    },
    durationLabel() {
      const duration = this.lessons.reduce((duration, lesson) => {
        if (Number.isSafeInteger(lesson.duration)) return duration + lesson.duration

        return duration
      }, 0)

      return this.$tc('masterclass.notice', duration, { duration })
    },
    status() {
      if (isMasterclassComplete(this.masterclass.id)) return 'finished'

      if (isMasterclassStarted(this.masterclass.id)) return 'running'

      return 'unstarted'
    },
    image() {
      return get(this.masterclass, 'tileImage', null)
    }
  },
  methods: {
    handleClick() {
      this.$router.push({ name: 'theme', params: { themeId: this.masterclass.id, image: this.image }})
    }
  }
}
</script>
